import * as et from '../../../application/EventTypes';
import { AnimatedVisibility } from "../AnimatedVisibility";

export const HUD_LAYER = Object.freeze({
  TRACE: { id: 'TRACE', defaultPrefs: { enabled: true } },
  LEVELS: { id: 'LEVELS', defaultPrefs: { enabled: true } },
  SPACES: { id: 'SPACES', defaultPrefs: { enabled: true } },
  ASSETS: { id: 'ASSETS', defaultPrefs: { enabled: false, tickets: true, alerts: true } }
});

export class HudLayer {
  facility;
  hud;
  isDirty;
  layerID;
  viewer;
  visibility;

  constructor(layerID, facility, hud, viewer) {
    this.facility = facility;
    this.hud = hud;
    this.viewer = viewer;
    this.dom = createDomLayer(hud.getDocument(), 'dt-hud-layer-' + layerID);

    this.layerID = layerID;
    this.isDirty = false;
    this.visibility = new AnimatedVisibility(this.dom, 0.0);
  }

  dispose() {}

  init() {
    return this;
  }

  invalidate() {
    this.isDirty = true;
  }

  isVisible() {
    return this.visibility.valueOf();
  }

  isOn() {
    return this.visibility.targetValue();
  }

  getState() {return { enabled: this.isOn() };}
  setState(state) {
    const visible = state.enabled;
    // Using isOn instead of isVisible to compare against "final" rather than animated visibility.
    if (this.isOn() !== visible) {
      this.setVisible(visible);
      if (visible) {
        this.hud.layers.updateAllUIPos([this]);
      }
    }
  }

  async setVisible(visible) {
    await this.visibility.set(visible);

    // Only deals with reaching the end state, add another start event if/when required.
    this.viewer.dispatchEvent({
      type: et.LAYER_VISIBILITY_CHANGED_EVENT,
      layerID: this.layerID,
      isOn: this.isOn()
    });
  }

  update(ts) {}
  compose(compositor, priority) {}

  clear() {}
  onSelectionChanged(selections) {}
  onIsolationChanged(isolation) {}
  onHiddenChanged({ hidden }) {}
  onFacetsUpdated(event) {}
  onFacetsLoaded(event) {}
  onModelChanged(event) {}
  onCameraChanged(camera) {}
  onClusterTransition(type, layerPrefs, isClustered) {
    switch (type) {
      case et.TRANSITION_STARTED:
        return this.isVisible() && this.setVisible(false);
      case et.TRANSITION_ENDED:
        return layerPrefs.enabled && this.setVisible(true);
    }
  }

  handleMouseMove(event) {} // ToolController event
  // Since every layer hold UI references differently, provides common enumeration interface.
  uis() {return [].values();}
}

// Create a minimal, non-sized, div for grouping and layout purposes.
export function createDomLayer(document, id) {
  const div = document.createElement('div');
  div.id = id;
  div.style.width = '0';
  div.style.height = '0';
  return div;
}